import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';

type Props = {
  mode: '登録' | '更新';
  values: ApiKeyTemplate;
  handleBack: () => void;
  handleSubmit: () => void;
};

export const ApiKeyTemplateRegistrationConfirmModalView: FC<Props> = ({
  mode,
  values,
  handleBack,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">APIキーテンプレートの{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>テンプレート名</FormLabel>
            <Input
              type="text"
              value={values.name}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>テンプレート</FormLabel>
            <Textarea
              value={values.template}
              rows={8}
              variant="flushed"
              isReadOnly
            />
          </FormControl>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          上記の内容でAPIキーテンプレートを{mode}しますか？
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          variant="outline"
          colorScheme="blackAlpha"
          onClick={handleBack}
        >
          入力画面に戻る
        </Button>
        <Button w="140px" colorScheme="blackAlpha" type="submit">
          {mode}
        </Button>
      </ModalFooter>
    </ModalContent>
  </form>
);
